import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RecuperarSenhaPage } from './recuperar-senha';

@NgModule({
  declarations: [
    RecuperarSenhaPage,
  ],
  imports: [
    IonicPageModule.forChild(RecuperarSenhaPage),
  ],
})
export class RecuperarSenhaPageModule {}



// WEBPACK FOOTER //
// ./src/pages/recuperar-senha/recuperar-senha.module.ts